import { render, staticRenderFns } from "./ReportedeReinicios.vue?vue&type=template&id=21890fea&scoped=true&"
import script from "./ReportedeReinicios.vue?vue&type=script&lang=js&"
export * from "./ReportedeReinicios.vue?vue&type=script&lang=js&"
import style0 from "./ReportedeReinicios.vue?vue&type=style&index=0&id=21890fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21890fea",
  null
  
)

export default component.exports